import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { graphqlRequest } from "context/graphql/functions";
import { AppAsyncThunkConfig } from "store";
import { State } from "./calendar.store";

export const createAppAsyncThunk = createAsyncThunk.withTypes<AppAsyncThunkConfig>();

export const asyncQueries = {
  getMobileCalendar: createAppAsyncThunk(
    "calendar/getMobileCalendar",
    async (_, { rejectWithValue, extra: { sdk } }) => {
      const { data, errors } = await graphqlRequest(sdk.getCalendar);
      if (errors) return rejectWithValue(errors);
      if (!data?.calendar) return rejectWithValue("something went wrong");
      return data;
    }
  ),
};

export const queryBuilder = (builder: ActionReducerMapBuilder<State>) => {
  builder.addCase(asyncQueries.getMobileCalendar.pending, (state) => {
    state.mobileCalendar.loading = true;
    return state;
  });
  builder.addCase(asyncQueries.getMobileCalendar.rejected, (state) => {
    state.mobileCalendar.loading = false;
    return state;
  });
  builder.addCase(asyncQueries.getMobileCalendar.fulfilled, (state, { payload: data }) => {
    state.mobileCalendar.loading = false;
    state.mobileCalendar.availability = [...data.calendar.availability];
    state.mobileCalendar.salesTasks = [...data.calendar.salesTasks];
    state.mobileCalendar.projectTasks = [...data.calendar.projectTasks];
    return state;
  });
};
